import styled, { css } from 'styled-components';
import { LinkWithIconWrapperProps } from '../types/SectionDigitalExperts.types';

export const BlockWrapper = styled.div`
  [class^='Blockstyle__Block-sc'] {
    padding: 32px 16px;

    @media (min-width: 768px) {
      padding: 64px 20px 56px 20px;
    }

    [class^='Blockstyle__ContentWrapper-sc'] {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1280px;
    }
  }
`;

export const HeadingWrapper = styled.div`
  margin-bottom: 16px;

  h3 {
    font-weight: 700;
    font-size: 28px;
  }

  @media (min-width: 768px) {
    margin-bottom: 28px;

    h3 {
      font-size: 40px;
    }
  }
`;

export const DescriptionWrapper = styled.div`
  div {
    margin-bottom: 32px;

    @media (min-width: 768px) {
      margin-bottom: 44px;
    }

    p {
      margin: 0;
    }
  }
`;

export const ExpertCardsWrapper = styled.div`
  @media (min-width: 639px) {
    flex-wrap: wrap;
    margin-bottom: 46px;
    display: flex;
    justify-content: center;
  }
`;

export const LinkWithIconWrapper = styled.div<LinkWithIconWrapperProps>`
  button {
    > div:first-child {
      transform: ${({ isRtl }) => (isRtl ? 'scaleX(-1)' : 'unset')};
    }
  }
`;

export const whiteCSS = css`
  background-color: var(--white);
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;